import { render, staticRenderFns } from "./EditorSettings.vue?vue&type=template&id=253561d2&"
import script from "./EditorSettings.vue?vue&type=script&lang=js&"
export * from "./EditorSettings.vue?vue&type=script&lang=js&"
import style0 from "./EditorSettings.vue?vue&type=style&index=0&id=253561d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports